// @ts-ignore

import React from "react";
import { ChevronDown, Building } from "lucide-react";
import { ignore } from "antd/es/theme/useToken";

const AccountSelector = ({
  accounts,
  selectedAccount,
  onAccountSelect,
  loading,
}: any) => {
  if (loading) {
    return (
      <div className="mb-6">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
          <div className="h-12 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  if (accounts.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Select Google Ads Account
      </label>

      <div className="relative">
        <select
          value={selectedAccount?.id || ""}
          onChange={(e) => {
            const account = accounts.find(
              (acc: any) => acc.id === e.target.value
            );
            if (account) onAccountSelect(account);
          }}
          className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
        >
          <option value="">Select an account</option>
          {accounts.map((account: any) => (
            <option key={account.id} value={account.id}>
              {account.name} ({account.id}) - {account.currency}
            </option>
          ))}
        </select>

        <Building className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
      </div>
    </div>
  );
};

export default AccountSelector;
